module.exports = {"Save":"Uložiť","chart.rowExceed":"Records count must be 500 and less","chart.selectTop":"Select top","chart.fetchingIds":"Selection finish...","search.hintText":"Píšte pre hľadanie (* pre všetko)","shipment.packagingSender":"Odosielateľ","Supplier":"Dodávateľ"}


//////////////////
// WEBPACK FOOTER
// ./src/core/common/locales/sk.json
// module id = 1356
// module chunks = 1